"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents a 2d point
 */
var Point = function () {
  /** @public */
  function Point() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Point);

    /**
     * The x-coordinate of the point
     * @type {number}
     */
    this.x = x;

    /**
     * The y-coordinate of the point
     * @type {number}
     */
    this.y = y;
  }

  /**
   * Returns a copy of this point
   * @return {Point}
   */


  _createClass(Point, [{
    key: "copy",
    value: function copy() {
      return new Point(this.x, this.y);
    }

    /**
     * Checks if two points are equal
     * @param {Point} point
     * @return {boolean}
     */

  }, {
    key: "equals",
    value: function equals(point) {
      return this.x === point.x && this.y === point.y;
    }

    /**
     * Returns true if this point is the origin
     * @return {boolean}
     */

  }, {
    key: "isOrigin",
    value: function isOrigin() {
      return this.x === 0 && this.y === 0;
    }
  }]);

  return Point;
}();

exports.default = Point;